import { useFlags } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";
import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { Redirect } from "react-router-dom";
import { Divider, Header, Message, Segment } from "semantic-ui-react";
import PermissionsService from "../../../services/permissions";
import useIsAdmin from "../../common/hooks/useIsAdmin";
import ProductCatalogPermissionsForm from "../components/form";

const initialCreateData = {
  agency_id: null,
  advertiser_ids: [],
  seller_ids: [],
  brands: [],
};
const backUrl = "/admin/product-catalog-permissions";
const permissionsService = new PermissionsService();

const ProductCatalogPermissionsCreatePage = ({ history }) => {
  const intl = useIntl();
  const { whitelabelRoiPixelEnabled } = useFlags();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverError, setServerError] = useState(null);

  const userIsAdmin = useIsAdmin();
  const goBack = useCallback(() => {
    history.push(backUrl);
  }, [history]);

  if (!(userIsAdmin || whitelabelRoiPixelEnabled)) {
    return <Redirect to="/campaigns" />;
  }

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    setServerError(null);
    try {
      await permissionsService.createPermission(values);
      history.push(backUrl, {
        action: "created",
      });
    } catch (e) {
      setServerError(e.error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Segment
      basic
      style={{ padding: "0" }}
    >
      <Header as="h2">
        {intl.formatMessage({
          id: "HEADING_CREATE_PRODUCT_CATALOG_PERMISSIONS",
          defaultMessage: "Create Product Catalog Permissions",
        })}
      </Header>
      <Divider />
      <Message
        style={{ marginTop: "10px" }}
        error
        hidden={!serverError}
        size="tiny"
        content={serverError}
      />
      <ProductCatalogPermissionsForm
        initialData={initialCreateData}
        isSubmitting={isSubmitting}
        submitText={intl.formatMessage({
          id: "BTN_CREATE_PERMISSION",
          defaultMessage: "Create Permission",
        })}
        onCancel={goBack}
        formType="create"
        onSubmit={handleSubmit}
      />
    </Segment>
  );
};

export default ProductCatalogPermissionsCreatePage;

ProductCatalogPermissionsCreatePage.propTypes = {
  history: PropTypes.object.isRequired,
};
